<template>
    <div class="SignaturesPane" v-observe-visibility="VisibilityChanged" style="display:flex;flex-direction:column; max-height:85vh;">
        <div ref="divtophalf">
            <h2>Signatures <font-awesome-icon :icon="['fa', 'sync-alt']" v-on:click="RefreshDataTable()" class="olive-green-text pointer table-refresh" /> <span v-b-tooltip.hover title="Hide/Show Filters"><font-awesome-icon :icon="ShowFilters ? 'eye' : 'eye-slash'" v-on:click="ToggleShowFilters()" class="pointer" /></span></h2>
            <div class="row" v-show="ShowFilters">
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Signature Type</label>
                        <select class="form-control" v-model="Filters.SignatureDocumentType">
                            <option value="RequiredByMe">Documents Requiring My Signature</option>
                            <option value="SignedByMe">Documents Signed By Me</option>
                            <option value="AuthoredByMe">Documents Authored By Me</option>
                        </select>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Search Signatures:</label>
                        <input type="text" v-model="search" class="form-control" @input="RedrawTable()" />
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <pagination 
                            v-model="PageNumber" 
                            :records="TotalRecordCount"
                            :per-page="PageSize"
                            @paginate="OnPaginate" />
            </div>
        </div>
        <div class="row" style="overflow:auto;padding-left:5px;padding-right:5px;">
            <vuetable :fields="SignatureTableOptions.Fields"
                      pagination-path=""
                      :api-mode="false"
                      class="vue-datatable"
                      :row-class="onRowClass"
                      ref="datatable"
                      :data-manager="DataManager" >


                <template slot="Actions" scope="props">
                    <div class="horizontal-icons-padded">
                        <span><font-awesome-icon :icon="['fa', 'eye']" v-on:click="ViewDocument(props.rowData.PDFFileID, props.rowData.FormLabel, props.rowData.PDFFileName, props.rowData.DocumentID)" class="pointer" /></span>
                        <span v-if="props.rowData.Actions == 'RequiredByMe'"><font-awesome-icon :icon="['fa', 'edit']" v-on:click="EditDocument(props.rowData.DocumentID)" class="pointer" /></span>
                        <span v-if="props.rowData.Actions != 'Locked'"><font-awesome-icon :icon="['fas', 'wrench']" v-on:click="OpenDocumentMiscOptions(props.rowData.ChartID, props.rowData.DocumentAuthorEmployeeID, props.rowData.DocumentID)" class="pointer" /></span>
                    </div>
                </template>
            </vuetable>
        </div>
        <DocumentViewer ref="document-viewer-modal-component" :reviewing="true" />
        <DocumentEditor ref="document-editor-modal-component" v-on:draftsupdated="GetDrafts()" :editing-submitted-document="true" />
        <DocumentMiscOptions ref="document-misc-options-modal-component" />
    </div>
</template>

<script>

    //import components
    import Pagination from 'vue-pagination-2';
    import Vuetable from 'vuetable-2/src/components/Vuetable'
    import DocumentEditor from "./DocumentEditor.vue";
    import DocumentViewer from "./DocumentViewer.vue";
    import DocumentMiscOptions from "./DocumentMiscOptions.vue";
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    import { faWrench } from '@fortawesome/free-solid-svg-icons';
    library.add(faWrench);
    import { faEye } from '@fortawesome/free-solid-svg-icons';
    library.add(faEye);
    import { faEyeSlash } from '@fortawesome/free-solid-svg-icons';
    library.add(faEyeSlash);

    import { EventBus } from '../../../services/event-bus.js';
    import { TableScrollerSupport } from "../../../mixins/TableScrollerSupport.js";

    export default {
        mixins: [TableScrollerSupport],
        created() {
            EventBus.$on('drafts-updated', chartId => {
                this.GetDrafts();
            });
        },
        beforeDestroy() {
            EventBus.$off('drafts-updated');
        },
        props: [
            "UserId"
        ],
        data: function () {
            return {
                PageNumber: 1,
                TotalRecordCount: 0,
                PageSize: 300,
                NumberOfSignatures: '',
                search: "",
                Drafts: [],
                Filters: {
                    SignatureDocumentType: "RequiredByMe"
                },
                SignatureTableOptions: {
                    Fields: [
                        {
                            name: 'FormLabel',
                            title: 'Name',
                            sortField: 'FormLabel'
                        },
                        {
                            name: 'EffectiveDate',
                            title: "Date",
                            callback: 'formatDate|MM/DD/YY',
                            sortField: 'EffectiveDate'
                        },
                        {
                            name: 'ChartName',
                            title: "Chart Name",
                            sortField: 'ChartName'
                        },
                        {
                            name: 'ChartType',
                            title: "Chart Type",
                            sortField: 'ChartType'
                        },
                        {
                            name: 'DocumentModifiedDate',
                            title: "Last Modified",
                            callback: 'formatDate|MM/DD/YY',
                            sortField: 'DocumentModifiedDate'
                        },
                        {
                            name: 'DocumentAuthorName',
                            title: 'Author',
                            sortField: 'DocumentAuthorName'
                        },
                        {
                            name: '__slot:Actions',
                            title: 'Actions'
                        }
                    ]
                }
            };
        },
        methods: {
            OnPaginate(pageNum) {
                this.PageNumber = pageNum;
                this.RefreshDataTable();
            },
            RefreshDataTable() {
                this.GetDrafts(true);
            },
            GetDrafts(showLoader = false) {
                this.$MasterAPI.ExecuteRequest("GET", "Core/Documents/GetSignatureDocuments", { SignatureDocumentType: this.Filters.SignatureDocumentType, PageNumber: this.PageNumber, PageSize: this.PageSize }, this.GetDraftsSuccess, () => { }, showLoader);
            },
            GetDraftsSuccess(response) {
                EventBus.$emit('documents-requiring-my-signature-updated', response.data.data.length);
                this.Drafts = response.data.data.Documents;
                this.TotalRecordCount = response.data.data.TotalRecords;
                this.$refs.datatable.refresh();
            },
            EditDocument(documentID) {
                this.$refs['document-editor-modal-component'].ShowExistingDocumentModal(documentID);
            },
            ViewDocument(pdfFileID, formLabel, documentName, documentID = null) {
                this.$refs['document-viewer-modal-component'].ShowViewerModal(pdfFileID, formLabel, documentName, documentID);
            },
            OpenDocumentMiscOptions(chartID, authorEmployeeID, documentID) {
                this.$refs['document-misc-options-modal-component'].ShowModal(chartID, authorEmployeeID, documentID, true, true, true);
            },
            formatDate(value, fmt = 'D MMM YYYY') {
                return (value == null)
                    ? ''
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            formatLongDate(value, fmt = 'D MMM YYYY') {
                return (value == null)
                    ? ''
                    : moment(value, 'YYYY-MM-DD ').format(fmt)
            },
            RedrawTable() {
                this.$refs.datatable.refresh();
            },
            DataManager(sortOrder, pagination) {
                let dataset = this.filteredList(this.Drafts);
                if (dataset.length > 0) {
                    if (sortOrder.length > 0) {
                        if (sortOrder[0].direction == 'asc') {
                            var firstComp = 1;
                            var secondComp = -1;
                        } else {
                            var firstComp = -1;
                            var secondComp = 1
                        }
                        return dataset.sort((a, b) => (this.$FindProperty(a, sortOrder[0].sortField) > this.$FindProperty(b, sortOrder[0].sortField)) ? firstComp : secondComp);
                    } else {
                        return dataset;
                    }
                    
                } else {
                    return [];
                }
            },
            filteredList(inputData) {
                let vm = this;
                let tData = inputData
                if (tData == null) {
                    return [];
                }
                let tFields = vm.$refs["datatable"].tableFields;
                let visibleData = [];
                tData.forEach(function (row, index) {
                    let rowData = [];
                    tFields.forEach(function (field) {
                        rowData.push(vm.$refs.datatable.renderNormalField(field, row));
                        
                    })
                    if (vm.search == "" || JSON.stringify(rowData).toLowerCase().includes(vm.search.toLowerCase())) {
                        visibleData.push(inputData[index]);
                    }
                });
                this.NumberOfSignatures = visibleData.length;
                return visibleData;                  
            },
            onRowClass(dataItem, index) {
                if (dataItem.IsRejected) {
                    return "document-rejected-row";
                } else {
                    return "";
                }
            },      

        },
        components: {
            Pagination,
            Vuetable,
            DocumentEditor,
            DocumentViewer,
            DocumentMiscOptions
        },
        computed: {

        },
        mounted() {

            //Get Child Records*/
            this.GetDrafts();

        }
    }
</script>

<style scoped>
    .horizontal-icons-padded span {
        padding-right: 20px;
    }
    /*sticky table header*/
    /deep/ .vue-datatable thead {
        position: sticky;
        top: -1px;
        background: white;
    }
    /*no wrap text on columns*/
    /deep/ .vue-datatable tbody td {
        white-space: nowrap !important;
    }

    .SignaturesPane {
        background-color: white;
    }
</style>